import React from 'react'
import SectionContainer from '../../../../Homepage/SectionContainer'
import BreadCrumb from '../../../../component/BreadCrumb/BreadCrumb'
import './BrandIdentity.css'
import img1 from "../../../../assets/kangaroo/1.png"
import { Link } from 'react-router-dom'

const BrandIndentity = () => {
    return (
        <div style={{ overflow: "hidden" }}>

            <SectionContainer>
                <BreadCrumb items={[
                    { title: "HOME", link: "/" },
                    { title: "BRAND IDENTITY GUIDELINE" },
                ]} instituition={false} className="" />
                <Link to="/brand-identity-guideline/brand" className="d-flex align-items-center text-decoration-none">

                    <h1 className="font-level-1 me-2">BRAND.</h1>
                    <img src={img1} alt="" className="img-fluid" style={{ width: "50px" }} />
                </Link>
                <Link to="/brand-identity-guideline/identity" className="d-flex align-items-center my-3 text-decoration-none">
                    <h1 className="font-level-1 me-2" style={{ color: "#D70A84" }}>IDENTITY.</h1>
                    <img src={img1} alt="" className="img-fluid" style={{ width: "50px" }} />
                </Link>
                <Link to="/brand-identity-guideline/guideline" className="d-flex align-items-center" style={{ marginBottom: "10rem", textDecoration: "none" }}>
                    <h1 className="font-level-1 me-2">GUIDELINES.</h1>
                    <img src={img1} alt="" className="img-fluid" style={{ width: "50px" }} />
                </Link>


            </SectionContainer>
        </div>
    )
}

export default BrandIndentity